export default "__VITE_ASSET__CG5AC_9o__"